export default function Services() {
  const services = [
    {
      icon: 'ri-car-line',
      title: 'Auto Accidents',
      description: 'Injured in a car accident? We connect you with experienced attorneys who specialize in auto accident claims in Las Cruces and Southern New Mexico.'
    },
    {
      icon: 'ri-building-line',
      title: 'Work Injuries',
      description: 'Hurt on the job? Our network includes top workers\' compensation lawyers who will fight for the benefits you deserve.'
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Slip & Fall',
      description: 'Injured on someone else\'s property? Our attorneys specialize in premises liability and slip and fall cases.'
    }
  ];

  return (
    <section id="services" className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            How We Can Help You
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            We specialize in connecting accident victims with the right legal and medical professionals in Las Cruces
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-[#FFF8F0] p-6 md:p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:transform hover:scale-105 text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#D2691E] rounded-full mb-4 md:mb-6 mx-auto">
                <i className={`${service.icon} text-2xl md:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}